import { Component, OnInit } from '@angular/core';
import { isHK } from 'app/app.component';

@Component({
  selector: 'app-info',
  templateUrl: './info.component.html',
  styleUrls: ['./info.component.css']
})
export class InfoComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }


  getIsHK(): boolean {
    return isHK;
  }

}



// WEBPACK FOOTER //
// /Users/michaldudziak/Desktop/Projekty/Projekt-Sunroof/Sunroof/src/app/info/info.component.ts